import { render } from "./failed.vue?vue&type=template&id=58ea1602&scoped=true"
import script from "./failed.vue?vue&type=script&lang=js"
export * from "./failed.vue?vue&type=script&lang=js"

import "./failed.vue?vue&type=style&index=0&id=58ea1602&scoped=true&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ea1602"]])

export default __exports__